import { PresentationChartIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const ContentAdvertising = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <PresentationChartIcon size={Sizes[size]} {...rest} />;
};

ContentAdvertising.displayName = 'ContentAdvertising';
